/* eslint-disable @typescript-eslint/naming-convention */
/**
 * Types of tracking event names (only for logs)
 */
export enum TrackingEventName {
    ACCORDION = 'accordion',
    FOOTNOTE_LINK = 'footnote link',
    TOOLTIP = 'tooltip hover',
    OPTION_PICKER = 'option picker',
    CAPTCHA = 'captcha',
    LM_FORM = 'lm form',
    OVERLAY = 'overlay',
}

/**
 * Types of tracking ui elements
 */
export enum TrackingUIType {
    FOOTNOTE = 'footnote',
    TOOLTIP = 'tool tip',
    LM_FORM = 'lead management',
    OVERLAY = 'overlay',
}

/**
 * Types of tracking triggers
 */
export enum TrackingTrigger {
    REFERENCE_FOOTNOTE = 'reference footnote',
    ICON = 'icon',
    BUTTON = 'button',
    CAPTCHA = 'availability-captcha-shown',
    AUTOMATICALLY = 'automatically',
}

/**
 * Step names of a tracking form
 */
export enum TrackingFormStepName {
    SHOW = 'show',
    START = 'start',
    COMPLETE = 'complete',
}

/**
 * Form statuses of a tracking form
 */
export enum TrackingFormStatus {
    START = 'start',
    END = 'end',
    SUCCESS = 'success',
}

/**
 * Product footprint of the address
 */
export enum TrackingFootprint {
    KDG = 'kabel deutschland',
    UME = 'unitymedia',
    DSL = 'mein dsl',
}

/**
 * Product types for tracking
 */
export enum TrackingProductType {
    KDG = 'cable',
    UME = 'cable (unity)',
    DSL = 'dsl',
    FIBER = 'fiber',
}

/**
 * State of the LM Form to track
 */
export enum LMFormTrackingState {
    OPEN = 'open',
    SUBMIT = 'submit',
}
